import { useEffect } from 'react'

import { useExperimentsContext } from '../../../../experiments/components/ExperimentsContext'
import { EXPERIMENT_NAME_PDP_PRODUCT_RECOMMENDATION } from '../../../../experiments/model/EXPERIMENT_NAME'

export const useProductRecommendationWidgetBuyTogetherProdRecActivation = (
  intersected: boolean,
): void => {
  const { addExperimentKeysForActivation } = useExperimentsContext()

  useEffect(() => {
    if (!intersected) {
      return
    }

    addExperimentKeysForActivation(EXPERIMENT_NAME_PDP_PRODUCT_RECOMMENDATION)
  }, [addExperimentKeysForActivation, intersected])
}
